import { render, staticRenderFns } from "./editDiv.vue?vue&type=template&id=0bc17548&"
import script from "./editDiv.vue?vue&type=script&lang=js&"
export * from "./editDiv.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports